import {lazy, Suspense} from "react";
import {useParams } from "react-router-dom"; 
import { Helmet } from 'react-helmet-async';
import {useTranslation} from "react-i18next"
import { ProgressSpinner } from 'primereact/progressspinner'; 
import { BlockUI } from 'primereact/blockui'

import "../../../styles/Menu.scss"; 
import "/node_modules/survey-core/defaultV2.css"; 
const RespondentSurveyPrivate = lazy(() => import('./RespondentSurveyPrivate'));
const RespondentSurveyPublic = lazy(() => import('./RespondentSurveyPublic'));

/**
 * The function is called when the survey is completed.
 */
export default function RespondentSurvey() {

    const { visible } = useParams(); 
    const { t } = useTranslation(); 

    const showContentRespondent = () =>  {
        if (visible === 'private' ) {
            return <RespondentSurveyPrivate />;
        } else {
            return <RespondentSurveyPublic />;
        }
    }

    const renderLoader = () =>  <BlockUI blocked={true} fullScreen> <ProgressSpinner /> </BlockUI>;

    return (
        <>
            <Helmet>
              <meta charSet="utf-8" />
              <title>{t('SEO.RESPONDENT_SURVEY.TITLE')}</title>
              <meta name="description" content={t('SEO.RESPONDENT_SURVEY.DESCRIPTION')} />
            </Helmet>
            <Suspense fallback={renderLoader()}>
                {showContentRespondent()}
            </Suspense>
        </>
    );
}